const WEBVIEW_STORAGE_KEY = 'isWebView';

function readTruthyFlag(value) {
  if (value == null) return false;
  const v = String(value).trim().toLowerCase();
  return v === '1' || v === 'true' || v === 'yes';
}

/** Persist ?webview=1 / ?in_app=1 / ?app=1 from the URL (used by Flutter deep links). */
export function persistWebViewFromQuery(search) {
  if (typeof window === 'undefined') return;
  const rawSearch = (search != null && search !== '')
    ? search
    : window.location.search;
  if (!rawSearch) return;
  const params = new URLSearchParams(rawSearch.startsWith('?') ? rawSearch : `?${rawSearch}`);
  const raw = params.get('webview') ?? params.get('in_app') ?? params.get('app');
  if (readTruthyFlag(raw)) {
    localStorage.setItem(WEBVIEW_STORAGE_KEY, '1');
  }
}

/**
 * True when the site is opened inside a native app WebView (e.g. Flutter APK),
 * not in a normal mobile browser tab.
 */
export function isInAppWebView() {
  if (typeof window === 'undefined') return false;

  if (window.isFlutterWebView === true || window.KOB_APP_WEBVIEW === true) {
    return true;
  }

  if (window.flutter_inappwebview) {
    return true;
  }

  if (readTruthyFlag(localStorage.getItem(WEBVIEW_STORAGE_KEY))) {
    return true;
  }

  const ua = navigator.userAgent || '';

  // Optional: Flutter app can append " KOBApp/1.0" (or similar) to userAgent
  if (/\bKOBApp\b/i.test(ua) || /\bKOB[\s_-]?WebView\b/i.test(ua)) {
    return true;
  }

  if (/flutter/i.test(ua)) {
    return true;
  }

  // Android System WebView — typical for Flutter webview_flutter APK builds
  if (/android/i.test(ua) && /; wv\)/.test(ua)) {
    return true;
  }

  return false;
}
